/**
 * TanStack Query hooks for `ios-14-server-side-consented-attribution-path`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	ios14ServerSideConsentedAttributionPathQueryKeys,
	type CreateIos14ServerSideConsentedAttributionPathBody,
	type ListIos14ServerSideConsentedAttributionPathResponse,
	type Ios14ServerSideConsentedAttributionPathRow,
} from "./api";

export function useIos14ServerSideConsentedAttributionPathList(): UseQueryResult<ListIos14ServerSideConsentedAttributionPathResponse, Error> {
	return useQuery({
		queryKey: ios14ServerSideConsentedAttributionPathQueryKeys.list(),
		queryFn: list,
	});
}

export function useIos14ServerSideConsentedAttributionPathCreate(): UseMutationResult<Ios14ServerSideConsentedAttributionPathRow, Error, CreateIos14ServerSideConsentedAttributionPathBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ios14ServerSideConsentedAttributionPathQueryKeys.all });
		},
	});
}

export function useIos14ServerSideConsentedAttributionPathDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ios14ServerSideConsentedAttributionPathQueryKeys.all });
		},
	});
}
